import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Dropdown} from "primereact/dropdown";
import {Calendar} from "primereact/calendar";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Message} from "primereact/message";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment/moment";
import {useNavigate, useParams} from "react-router-dom";

const _FM_ReservationRelocateFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {action, id } = useParams();
  const [loading, setLoading] = useState(false);
  const [reservation, setReservation] = useState({});
  const [units, setUnits] = useState([]);
  const [berths, setBerths] = useState([]);
  const [priceCategories, setPriceCategories] = useState([]);
  const [guestInfos, setGuestInfos] = useState([]);
  const [chooseBerth, setChooseBerth] = useState(false);
  const [formData, setFormData] = useState({
    residential_unit: null,
    berth: null,
    reserved_from_date: null,
    reserved_from_time: '15:00',
    reserved_to_date: null,
    reserved_to_time: '11:00',
    price_category: null,
    guest_information_request_page: null,
    note: '',
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    if (!props.reservationId) {
      return;
    }

    setLoading(true);
    apiCall('get', 'reservation/' + props.reservationId)
      .then(response => {
        setReservation(response.data.data || {});
        const _reservedFrom = response.data.data?.reserved_from ? new Date(response.data.data.reserved_from.toString()) : null;
        const _reservedTo = response.data.data?.reserved_to ? new Date(response.data.data.reserved_to.toString()) : null;
        setFormData((prev) => ({
          ...prev,
          residential_unit: response.data.data?.residential_unit?.id || response.data.data?.residential_unit || null,
          berth: response.data.data?.berth?.id || response.data.data?.berth || null,
          reserved_from_date: _reservedFrom
            ? `${_reservedFrom.getUTCFullYear()}-${String(_reservedFrom.getUTCMonth() + 1).padStart(2, '0')}-${String(_reservedFrom.getUTCDate()).padStart(2, '0')}`
            : null,
          reserved_from_time: _reservedFrom
            ? `${String(_reservedFrom.getUTCHours() + 1).padStart(2, '0')}:${String(_reservedFrom.getUTCMinutes()).padStart(2, '0')}`
            : '15:00',
          reserved_to_date: _reservedTo
            ? `${_reservedTo.getUTCFullYear()}-${String(_reservedTo.getUTCMonth() + 1).padStart(2, '0')}-${String(_reservedTo.getUTCDate()).padStart(2, '0')}`
            : null,
          reserved_to_time: _reservedTo
            ? `${String(_reservedTo.getUTCHours() + 1).padStart(2, '0')}:${String(_reservedTo.getUTCMinutes()).padStart(2, '0')}`
            : '11:00',
          price_category: response.data.data?.price_category?.id || response.data.data?.price_category || null,
          guest_information_request_page: response.data.data?.guest_information_request_page?.id || response.data.data?.guest_information_request_page || null,
          note: response.data.data?.note || '',
        }));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });

    apiCall('get', 'residential-unit')
      .then(response => {
        setUnits((response.data.data.items || []).map((unitItem) => {
          const accommodationName = unitItem?.residential_category?.accommodation?.name;
          return {
            ...unitItem,
            name: accommodationName ? `${unitItem?.name} (${accommodationName})` : unitItem?.name,
          };
        }));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });

    apiCall('get', 'guest-information-request-page')
      .then(response => {
        setGuestInfos(response.data.data.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [props.reservationId]);

  useEffect(() => {
    if (!formData.residential_unit) {
      setBerths([]);
      setPriceCategories([]);
      setChooseBerth(false);
      return;
    }

    setChooseBerth(false);

    apiCall('get', 'berth?search[residential_unit][operator]=%3D&search[residential_unit][value]=' + formData.residential_unit)
      .then(response => {
        setBerths(response.data.data.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });

    apiCall('get', 'residential-unit/' + formData.residential_unit)
      .then(response => {
        if (response.data.data && response.data.data.residential_category && response.data.data.residential_category.id) {
          apiCall('get', 'residential-category/' + response.data.data.residential_category.id)
            .then(response => {
              if (response.data.data && response.data.data.accommodation && response.data.data.accommodation.id) {
                apiCall('get', 'price-category?search[accommodation][operator]=%3D&search[accommodation][value]=' + response.data.data.accommodation.id)
                  .then(response => {
                    setPriceCategories(response.data.data.items || []);
                  })
                  .catch(error => {
                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                  })
              }
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
            })
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [formData.residential_unit]);

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col p-col-align-center"} >
          <h2 className={""}>{t('reservation_relocate_title')}</h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"} style={{maxWidth: '60px'}}>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    if (window.location.hash.toString().includes('#/reservation')) {
                      navigate('/reservation/' + action + "/" + id)
                    }
                    if (window.location.hash.toString().includes('#/calendar')) {
                      navigate('/calendar/' + action + "/" + id)
                    }
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
       <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-4"}>
            <Panel className={"p-mt-0"}>
              <h3 className={"p-mt-0 p-mb-3"}>{t('current_reservation_segment')}</h3>

              <div className="p-field p-fluid">
                <label htmlFor="current_contact">{t('guest_or_contact')}</label>
                <span id="current_contact" className="p-d-block p-text-bold">{reservation?.contact_name || '-'}</span>
              </div>

              <div className="p-field p-fluid">
                <label htmlFor="current_unit_or_berth">{t('current_unit_or_berth')}</label>
                <span id="current_unit_or_berth" className="p-d-block p-text-bold">
                  {reservation?.berth?.name
                    ? reservation?.berth?.name + (reservation?.residential_unit?.name ? ' (' + reservation?.residential_unit?.name + ')' : '')
                    : reservation?.residential_unit?.name || '-'}
                </span>
              </div>

              <div className="p-field p-fluid">
                <label htmlFor="current_stay">{t('original_stay')}</label>
                <span id="current_stay" className="p-d-block p-text-bold">
                  {reservation?.reserved_from ? moment.utc(reservation.reserved_from).local().format(t('YYYY-MM-DD HH:mm')) : '-'}
                  {' -> '}
                  {reservation?.reserved_to ? moment.utc(reservation.reserved_to).local().format(t('YYYY-MM-DD HH:mm')) : '-'}
                </span>
              </div>

              <Message severity="warn" text={t('relocate_old_reservation_end_hint')} className={"w-100"}/>
            </Panel>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <Panel className={"p-mt-0"}>
              <h3 className={"p-mt-0 p-mb-3"}>{t('new_relocated_stay')}</h3>

              <div className="p-field p-fluid">
                <label htmlFor="reserved_from">{t('move_date_time')}</label>
                <span className="p-inputgroup p-d-flex p-mt-1">
                  <Calendar value={formData.reserved_from_date ? moment(formData.reserved_from_date, 'YYYY-MM-DD').toDate() : null}
                            id={"reserved_from"}
                            locale="default"
                            dateFormat={t('YY-MM-DD')}
                            showIcon
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reserved_from_date: e.value ? moment.utc(e.value).local().format(t('YYYY-MM-DD')) : null
                              })
                            }}/>
                  <Calendar value={formData.reserved_from_time ? moment(formData.reserved_from_time, 'HH:mm').toDate() : null}
                            locale="default"
                            dateFormat={t('YY-MM-DD')}
                            showIcon
                            showTime
                            timeOnly
                            hourFormat="24"
                            stepMinute={30}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reserved_from_time: e.value ? moment.utc(e.value).local().format('HH:mm') : null
                              })
                            }}/>
                </span>
              </div>

              <div className="p-field p-fluid">
                <label htmlFor="reserved_to">{t('new_end_date_time')}</label>
                <span className="p-inputgroup p-d-flex p-mt-1">
                  <Calendar value={formData.reserved_to_date ? moment(formData.reserved_to_date, 'YYYY-MM-DD').toDate() : null}
                            id={"reserved_to"}
                            locale="default"
                            dateFormat={t('YY-MM-DD')}
                            showIcon
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reserved_to_date: e.value ? moment.utc(e.value).local().format(t('YYYY-MM-DD')) : null
                              })
                            }}/>
                  <Calendar value={formData.reserved_to_time ? moment(formData.reserved_to_time, 'HH:mm').toDate() : null}
                            locale="default"
                            dateFormat={t('YY-MM-DD')}
                            showIcon
                            showTime
                            timeOnly
                            hourFormat="24"
                            stepMinute={30}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reserved_to_time: e.value ? moment.utc(e.value).local().format('HH:mm') : null
                              })
                            }}/>
                </span>
              </div>

              <div className="p-field p-fluid">
                <label htmlFor="residential_unit">{t('new_place')}</label>
                <span className="p-inputgroup p-d-flex p-mt-1">
                  <Dropdown  options={units}
                            optionLabel="name"
                            optionValue="id"
                            filter
                            id={"residential_unit"}
                            emptyMessage={t('empty_message')}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                residential_unit: e.value,
                                berth: null
                              })
                            }}
                            value={formData.residential_unit}
                  />
                  {(chooseBerth === false && formData.residential_unit && berths && berths[0] && priceCategories && priceCategories[0] && !formData.berth) &&
                    <Button icon="pi pi-inbox"
                            label={t('reserve_berth')}
                            className="p-button-secondary"
                            type={"button"}
                            onClick={() => {
                              setChooseBerth(true)
                            }}
                    />
                  }
                </span>
              </div>

              {(formData.residential_unit && berths && berths[0] && priceCategories && priceCategories[0] && (chooseBerth === true || formData.berth)) &&
                <div className="p-field p-fluid">
                  <label htmlFor="berth">{t('berth')}</label>
                  <span className="p-d-block p-mt-1">
                    <Dropdown  options={berths}
                              optionLabel="name"
                              optionValue="id"
                              filter
                              id={"berth"}
                              emptyMessage={t('empty_message')}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  berth: e.value
                                })
                              }}
                              value={formData.berth}
                              showClear
                    />
                  </span>
                </div>
              }

              <div className="p-field p-fluid">
                <label htmlFor="price_category">{t('pricecategory')}</label>
                <span className="p-d-block p-mt-1">
                  <Dropdown  options={priceCategories}
                            optionLabel="name"
                            optionValue="id"
                            id={"price_category"}
                            emptyMessage={t('empty_message')}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                price_category: e.value
                              })
                            }}
                            value={formData.price_category}
                            showClear
                  />
                </span>
              </div>

              <div className="p-field p-fluid">
                <label htmlFor="guest_information_request_page">{t('guest_information_request_page')}</label>
                <span className="p-d-block p-mt-1">
                  <Dropdown  options={guestInfos}
                            optionLabel="name"
                            optionValue="id"
                            id={"guest_information_request_page"}
                            emptyMessage={t('empty_message')}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                guest_information_request_page: e.value
                              })
                            }}
                            value={formData.guest_information_request_page}
                            showClear
                  />
                </span>
              </div>

              <div className="p-field p-fluid">
                <label htmlFor="note">{t('optional_note')}</label>
                <span className="p-d-block p-mt-1">
                  <InputText id="note"
                             onChange={(e) => {
                               setFormData({
                                 ...formData,
                                 note: e.target.value
                               })
                             }}
                             value={formData.note}
                  />
                </span>
              </div>

              <div className={"p-text-right"}>
                <Button type="button"
                        className="p-button-success"
                        icon={"pi pi-sign-in"}
                        loading={loading}
                        disabled={
                          !formData.residential_unit
                          || !formData.reserved_from_date
                          || !formData.reserved_from_time
                          || !formData.reserved_to_date
                          || !formData.reserved_to_time
                          || !formData.price_category
                          || !formData.guest_information_request_page
                          || !reservation?.id
                          || !moment(formData.reserved_from_date + ' ' + formData.reserved_from_time, 'YYYY-MM-DD HH:mm').isBefore(moment(formData.reserved_to_date + ' ' + formData.reserved_to_time, 'YYYY-MM-DD HH:mm'))
                        }
                        label={t('relocate')}
                        onClick={() => {
                          setLoading(true);
                          const _fromDatePart = moment.utc(formData.reserved_from_date).local().format('YYYY-MM-DD');
                          const _fromTimePart = formData.reserved_from_time;
                          const [_fromHour, _fromMinute] = _fromTimePart.split(":");
                          const _fromAdjustedHour = (parseInt(_fromHour, 10) - 1).toString().padStart(2, "0");
                          const _fromCombinedString = `${_fromDatePart}T${_fromAdjustedHour}:${_fromMinute}:00Z`;
                          const _toDatePart = moment.utc(formData.reserved_to_date).local().format('YYYY-MM-DD');
                          const _toTimePart = formData.reserved_to_time;
                          const [_toHour, _toMinute] = _toTimePart.split(":");
                          const _toAdjustedHour = (parseInt(_toHour, 10) - 1).toString().padStart(2, "0");
                          const _toCombinedString = `${_toDatePart}T${_toAdjustedHour}:${_toMinute}:00Z`;

                          apiCall('post', 'reservation/' + reservation.id + '/relocate', {
                            residential_unit: formData.residential_unit,
                            berth: formData.berth || null,
                            reserved_from: new Date(_fromCombinedString),
                            reserved_to: new Date(_toCombinedString),
                            price_category: formData.price_category,
                            reservation_group: reservation?.reservation_group?.id || reservation?.reservation_group,
                            guest_information_request_page: formData.guest_information_request_page,
                            contact_email: reservation?.contact_email,
                            contact_number: reservation?.contact_number,
                            contact_name: reservation?.contact_name,
                            number_of_guests: reservation?.number_of_guests,
                            status: 'confirmed',
                            note: formData.note,
                          })
                            .then(response => {
                              window.App.toastShow('success', t('success'), response.data.message)
                              window.App.setState({
                                rerenderReservationList: Math.random(),
                                rerenderReservationGuestList: Math.random(),
                              })
                              if(window.location.hash.toString().includes('#/reservation')) {
                                navigate('/reservation/read/' + id)
                              }
                              if(window.location.hash.toString().includes('#/calendar')) {
                                navigate('/calendar/read/' + id)
                              }
                            })
                            .catch(error => {
                              window.App.toastShow(
                                'error',
                                t('error'),
                                error.response?.data?.message || error.toString(),
                                '',
                                error.response,
                                error.response?.data?.data?.url
                              )
                            })
                            .finally(() => {
                              setLoading(false)
                            })
                        }}/>
              </div>
            </Panel>
          </div>
         <div className={"p-col-12 p-lg-4"}>
           <Panel className={"p-mt-"}>
             <h4 className={"p-mt-0 p-mb-3"}>{t('live_summary')}</h4>

             <div className="p-field p-fluid">
               <label htmlFor="old_reservation_summary">{t('old_reservation')}</label>
               <span id="old_reservation_summary" className="p-d-block p-text-bold">
            {reservation?.reserved_from ? moment.utc(reservation.reserved_from).local().format(t('YYYY-MM-DD HH:mm')) : '-'}
                 {' -> '}
                 {formData.reserved_from_date && formData.reserved_from_time
                   ? moment(formData.reserved_from_date + ' ' + formData.reserved_from_time, 'YYYY-MM-DD HH:mm').format(t('YYYY-MM-DD HH:mm'))
                   : '-'}
          </span>
             </div>

             <div className="p-field p-fluid">
               <label htmlFor="new_reservation_summary">{t('new_reservation')}</label>
               <span id="new_reservation_summary" className="p-d-block p-text-bold">
            {formData.reserved_from_date && formData.reserved_from_time
              ? moment(formData.reserved_from_date + ' ' + formData.reserved_from_time, 'YYYY-MM-DD HH:mm').format(t('YYYY-MM-DD HH:mm'))
              : '-'}
                 {' -> '}
                 {formData.reserved_to_date && formData.reserved_to_time
                   ? moment(formData.reserved_to_date + ' ' + formData.reserved_to_time, 'YYYY-MM-DD HH:mm').format(t('YYYY-MM-DD HH:mm'))
                   : '-'}
          </span>
             </div>

             <Message severity="info" text={t('reservation_group_unchanged')} className={"w-100"}/>
           </Panel>
         </div>
        </div>


    </>
  )
}

export default withTranslation('common')(_FM_ReservationRelocateFormComponent);
